import { render, staticRenderFns } from "./ShopMessageView.vue?vue&type=template&id=4e360fa8&scoped=true&"
import script from "./ShopMessageView.vue?vue&type=script&lang=ts&"
export * from "./ShopMessageView.vue?vue&type=script&lang=ts&"
import style0 from "./ShopMessageView.vue?vue&type=style&index=0&id=4e360fa8&lang=scss&scoped=true&"
import style1 from "./ShopMessageView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e360fa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e360fa8')) {
      api.createRecord('4e360fa8', component.options)
    } else {
      api.reload('4e360fa8', component.options)
    }
    module.hot.accept("./ShopMessageView.vue?vue&type=template&id=4e360fa8&scoped=true&", function () {
      api.rerender('4e360fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopMessageView.vue"
export default component.exports